/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { EmrPtrLabResultsViewModel } from '../models/emr-ptr-lab-results-view-model';
import { FindFilter } from '../models/find-filter';
import { LookupValueModel } from '../models/lookup-value-model';
@Injectable({
  providedIn: 'root',
})
class EmrPtrLabResultsViewService extends __BaseService {
  static readonly GetAllDomainPath = '/api/hir/EmrPtrLabResultsView/AllDomain';
  static readonly FindInDomainPath = '/api/hir/EmrPtrLabResultsView/FindInDomain';
  static readonly LookupsPath = '/api/hir/EmrPtrLabResultsView/Lookups';
  static readonly DistinctStringLookupsPath = '/api/hir/EmrPtrLabResultsView/DistinctStringLookups';
  static readonly UpdatePath = '/api/hir/EmrPtrLabResultsView';
  static readonly AddPath = '/api/hir/EmrPtrLabResultsView';
  static readonly DeletePath = '/api/hir/EmrPtrLabResultsView';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  GetAllDomainResponse(): __Observable<__StrictHttpResponse<Array<EmrPtrLabResultsViewModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/hir/EmrPtrLabResultsView/AllDomain`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EmrPtrLabResultsViewModel>>;
      })
    );
  }
  /**
   * @return Success
   */
  GetAllDomain(): __Observable<Array<EmrPtrLabResultsViewModel>> {
    return this.GetAllDomainResponse().pipe(
      __map(_r => _r.body as Array<EmrPtrLabResultsViewModel>)
    );
  }

  /**
   * @param findFilter undefined
   * @return Success
   */
  FindInDomainResponse(findFilter?: FindFilter): __Observable<__StrictHttpResponse<Array<EmrPtrLabResultsViewModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = findFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/hir/EmrPtrLabResultsView/FindInDomain`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<EmrPtrLabResultsViewModel>>;
      })
    );
  }
  /**
   * @param findFilter undefined
   * @return Success
   */
  FindInDomain(findFilter?: FindFilter): __Observable<Array<EmrPtrLabResultsViewModel>> {
    return this.FindInDomainResponse(findFilter).pipe(
      __map(_r => _r.body as Array<EmrPtrLabResultsViewModel>)
    );
  }

  /**
   * @return Success
   */
  LookupsResponse(): __Observable<__StrictHttpResponse<{[key: string]: Array<LookupValueModel>}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/hir/EmrPtrLabResultsView/Lookups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: Array<LookupValueModel>}>;
      })
    );
  }
  /**
   * @return Success
   */
  Lookups(): __Observable<{[key: string]: Array<LookupValueModel>}> {
    return this.LookupsResponse().pipe(
      __map(_r => _r.body as {[key: string]: Array<LookupValueModel>})
    );
  }

  /**
   * @return Success
   */
  DistinctStringLookupsResponse(): __Observable<__StrictHttpResponse<{[key: string]: Array<string>}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/hir/EmrPtrLabResultsView/DistinctStringLookups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: Array<string>}>;
      })
    );
  }
  /**
   * @return Success
   */
  DistinctStringLookups(): __Observable<{[key: string]: Array<string>}> {
    return this.DistinctStringLookupsResponse().pipe(
      __map(_r => _r.body as {[key: string]: Array<string>})
    );
  }

  /**
   * @param obj undefined
   * @return Success
   */
  UpdateResponse(obj?: EmrPtrLabResultsViewModel): __Observable<__StrictHttpResponse<EmrPtrLabResultsViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = obj;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/hir/EmrPtrLabResultsView`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EmrPtrLabResultsViewModel>;
      })
    );
  }
  /**
   * @param obj undefined
   * @return Success
   */
  Update(obj?: EmrPtrLabResultsViewModel): __Observable<EmrPtrLabResultsViewModel> {
    return this.UpdateResponse(obj).pipe(
      __map(_r => _r.body as EmrPtrLabResultsViewModel)
    );
  }

  /**
   * @param obj undefined
   * @return Success
   */
  AddResponse(obj?: EmrPtrLabResultsViewModel): __Observable<__StrictHttpResponse<EmrPtrLabResultsViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = obj;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/hir/EmrPtrLabResultsView`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EmrPtrLabResultsViewModel>;
      })
    );
  }
  /**
   * @param obj undefined
   * @return Success
   */
  Add(obj?: EmrPtrLabResultsViewModel): __Observable<EmrPtrLabResultsViewModel> {
    return this.AddResponse(obj).pipe(
      __map(_r => _r.body as EmrPtrLabResultsViewModel)
    );
  }

  /**
   * @param obj undefined
   * @return Success
   */
  DeleteResponse(obj?: EmrPtrLabResultsViewModel): __Observable<__StrictHttpResponse<EmrPtrLabResultsViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = obj;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/hir/EmrPtrLabResultsView`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EmrPtrLabResultsViewModel>;
      })
    );
  }
  /**
   * @param obj undefined
   * @return Success
   */
  Delete(obj?: EmrPtrLabResultsViewModel): __Observable<EmrPtrLabResultsViewModel> {
    return this.DeleteResponse(obj).pipe(
      __map(_r => _r.body as EmrPtrLabResultsViewModel)
    );
  }
}

module EmrPtrLabResultsViewService {
}

export { EmrPtrLabResultsViewService }
